import { PAGE_HOME_INCLUSIONE, PAGE_HOME_URL, PAGE_INCLUSIONE_APPRENDIMENTO_ITALIANO } from 'types/url';

export const breadcrumbPath = [
  {
    slash: 'Home',
    url: PAGE_HOME_URL,
  },
  {
    slash: 'WeMi inclusione',
    url: PAGE_HOME_INCLUSIONE,
  },
  {
    slash: 'Apprendimento della lingua italiana',
    url: PAGE_INCLUSIONE_APPRENDIMENTO_ITALIANO,
  },
  {
    slash: 'corso di italiano a Milano',
    url: '',
  },
];

export const title = 'WeMi - Inclusione - Apprendimento della lingua italiana - corso di italiano a Milano';
export const description = 'Descrizione servizio corso di italiano a Milano';
export const keywords = 'welfare, milano, servizi, servizio, Apprendimento della lingua italiana corso di italiano a Milano , servizio Apprendimento della lingua italiana, informazioni Apprendimento della lingua italiana, informazioni corso di italiano a Milano';
